import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import StoreIcon from '@mui/icons-material/Store';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BusinessIcon from '@mui/icons-material/Business';
import BuildIcon from '@mui/icons-material/Build';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'; // new group icon

const icons = {
  AdminPanelSettingsIcon,
  PersonAddIcon,
  StoreIcon,
  HandshakeIcon,
  BusinessIcon,
  BuildIcon,
  SupervisorAccountIcon
};


const userCreation = {
  id: 'userCreation',
  type: 'group',
  icon: icons.SupervisorAccountIcon,
  children: [
    {
      id: 'createUser',
      title: 'Create User',
      type: 'item',
      url: '/create-user',
      icon: icons.PersonAddIcon,
      // breadcrumbs: false
    },
  ]
};

export default userCreation;
